import client from '@/store/client'
import qs from 'query-string'
import { parseStringPromise } from 'xml2js'
import parseData from '../util/parsedata'
import _ from 'lodash'

function nestObjects(parentArray, childArray){
  childArray.forEach( child => {
    parentArray.forEach( parent => {
      if(child.ParentCategoryTreeID == parent.TreeID){
        if(!parent.children) parent.children = []
        parent.children.push({...child, CategoryTreePathForwards: child.CategoryTreePathForwards[child.CategoryTreeLevel - 1]})
      }
    })
  })
}

function splitChildren(items){
  items.forEach(el => {
    el.CategoryTreePathForwards = el.CategoryTreePathForwards.split(' / ')
  })
  let partitionedByLevel = _.values(_.groupBy(items, 'CategoryTreeLevel'))
  _.forEachRight(partitionedByLevel, (level, i) => {
    if ( i == 0 ) return
    nestObjects(partitionedByLevel[i-1], level)
  })
  partitionedByLevel[1].forEach(item => {
    item.CategoryTreePathForwards = item.CategoryTreePathForwards[1]
  })
  return partitionedByLevel[1]
}

function mappingString(items){
  let mapString = ''
  items.forEach( item => {
    mapString += `${item.ID},${item.TreeID},Y;`
  })
  return mapString
}

const getDefaultState = () => {
  return {
    tagId: '',
    tagName: '',
    tagText: '',
    tagImage: '',
    tagDisplayOrder: '',
    revision: '',
    associatedCategories: [],
    categoryTreeGroupID: '1',
    languageID: '1',
    categoryTreeID: '0',
    allCategoryTreeGroups: [],
    allCategoryTrees: []
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    nameStartsWith: '',
    descripStartsWith: '',
    totalOnServer: -1,
    searchResults: [],
    allLanguages: [],
    tableHeaders:[
      {
        text: 'ID',
        value: 'ID'
      },
      {
        text: 'Name',
        value: 'RetailerTagName'
      },
      {
        text: 'Message',
        value: 'RetailerTagDescription'
      },
      {
        text: 'Image Name',
        value: 'RetailerTagImage'
      },
      {
        text: 'Display Order',
        value: 'DisplayOrder'
      },
    ]
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    GET_LANGUAGES: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Lookup.asmx/GetLanguages', qs.stringify(this.getters['traceToken']))
        commit('setLanguages', await parseData(APIRes.data))
      }
      catch (err){
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })
      }
    },
    SEARCH_RETAILER_TAGS: async function({commit, getters}, data){
      const searchData = {
        ...getters['findRetailerTagData'],
        retailerID: data.retailerid,
        recordsPerPageCount: data.itemsPerPage,
        recordIndex: data.page,
        retailerTagSortField: data.sortBy || 'RetailerTagName' ,
        retailerTagSortOrder: data.order || 'asc'
      }
      const APIRes = await client.post('/v1/MacroMessage.asmx/GetMacroMessage', qs.stringify(searchData))
      const parsedData = await parseData(APIRes.data)
      const response = await parseStringPromise(APIRes.data)
      commit('setField', { key: 'totalOnServer', value: +response.content.data[0].$.Count })
      commit('setSearchResults', parsedData)
    },
    INSERT_RETAILER_TAG: async function({commit}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Retailer Tag',
          subdetail: 'Please wait...',
        })
        const APIRes = await client.post('/v1/MacroMessage.asmx/InsertMacroMessage', qs.stringify(this.getters['retailerTag/currentRetailerTag']))
        const parsedRes = await parseStringPromise(APIRes.data)
        commit('setField', { key: 'tagId', value: parsedRes.content.data[0].$.ID })
        commit('setField', { key: 'revision', value: 0 })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Retailer Tag has been successfully created`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Retailer Tag was not created',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_RETAILER_TAG: async function({state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Retailer Tag',
          subdetail: 'Please wait...',
        })
        const updateData = {
          ...this.getters['retailerTag/currentRetailerTag'],
          RetailerTagID: state.tagId,
          revision: state.revision,
          RetailerTagName: state.tagName,
          RetailerTagDescription: state.tagText,
          RetailerTagImage: state.tagImage
        }
        await client.post('/v1/MacroMessage.asmx/UpdateMacroMessage', qs.stringify(updateData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Retailer Tag has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Retailer Tag was not updated',
          subdetail: err.response.data,
        })
      }
    },
    GET_ASSOCIATED_CATEGORIES: async function({commit}){
      try {
        const associationsData = {
          ...this.getters['retailerTag/categoryAssociations'],
          CategoryTreeGroupID: 0,
          LanguageID: 0,
        }
        const APIRes = await client.post('/v1/Retailers.asmx/GetCategoriesAssociatedToRetailerTag', qs.stringify(associationsData))
        commit('setAssociatedCategories', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Error getting category associations',
          subdetail: err.response.data,
        })
      }
    },
    REMOVE_ASSOCIATION: async function({getters}, data){
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Removing Category',
          subdetail: 'Please wait...',
        })
        const associationsData = {
          ...getters['categoryAssociations'],
          CategoryTreeGroupID: data.CategoryTreeGroupID,
          CategoryTreeID: data.TreeID,
          CategoryID: data.ID
        }
        await client.post('/v1/Retailers.asmx/DissociateCategoryFromRetailerTag', qs.stringify(associationsData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Category has been removed successfully`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Error removing category associations',
          subdetail: err.response.data,
        })
      }
    },
    SET_CURRENT_TAG: function({commit}, data){
      commit('setCurrentTag', data )
    },
    GET_RETAILER_TREES: async function({ commit }){
      try {
        const APIRes = await client.post('/v1/Retailers.asmx/GetCategoryTreeGroupsAssociatedWithRetailer', qs.stringify(this.getters['retailerTag/currentRetailerTag']))
        commit('setField', { key: 'allCategoryTreeGroups', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })
      }
    },
    GET_TREE_CATEGORIES: async function({commit, state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting data',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...this.getters['traceToken'],
          CategoryTreeGroupID: state.categoryTreeGroupID,
          LanguageID: state.languageID,
          CategoryTreeID: state.categoryTreeID
        }
        const APIRes = await client.post('/v1/CategoryTree.asmx/GetCategoriesInCategoryTreeGroup', qs.stringify(APIData))
        const parsedRes = await parseData(APIRes.data)
        let treeItems = []
        if (parsedRes) treeItems = parsedRes.map(item => {
          if (item.Count != 0) item['children'] = []
          return item
        })
        commit('setField', { key: 'allCategoryTrees', value: treeItems })
        const allItems = this.getters['retailerTag/getTreeList']
        for (let i = 0; i < allItems.length; i++) {
          if (allItems[i].children) await this.dispatch('retailerTag/UPDATE_TREE_CHILD', allItems[i].TreeID) 
        }
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Redirecting...',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Could not get Categories',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_TREE_CHILD: async function({commit, state}, data){
      try {
        const APIData = {
          ...this.getters['traceToken'],
          CategoryTreeGroupID: state.categoryTreeGroupID,
          LanguageID: state.languageID,
          CategoryTreeID: data
        }
        const APIRes = await client.post('/v1/CategoryTree.asmx/GetCategoriesInCategoryTreeGroup', qs.stringify(APIData))
        const parsedRes = await parseData(APIRes.data)
        commit('updateTreeChild', { treeId: data, children: splitChildren(parsedRes) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Could not get tree children',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_ASSOCIATIONS: async function({getters, state}, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Category',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...getters['categoryAssociations'],
          CategoryTreeGroupID: state.categoryTreeGroupID,
          Mappings: mappingString(data)
        }
        await client.post('/v1/Retailers.asmx/UpdateCategoryAssociationsToRetailerTag', qs.stringify(APIData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Category has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Could not updated',
          subdetail: err.response.data,
        })
      }
    }
  },
  getters: {
    findRetailerTagData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        retailerTagName: state.nameStartsWith,
        retailerTagDescription: state.descripStartsWith,
      }
    },
    currentRetailerTag: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        merchantID: rootState.retailer.retailerInfo.MerchantID,
        retailerID: rootState.retailer.retailerInfo.ID,
        displayorder: state.tagDisplayOrder || '0',
        name: state.tagName,
        description: state.tagText,
        image: state.tagImage
      }
    },
    categoryAssociations: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        merchantID: rootState.retailer.retailerInfo.MerchantID,
        retailerID: rootState.retailer.retailerInfo.ID,
        RetailerTagID: state.tagId,
        UpdatedBy: rootState.user.username
      }
    },
    getTreeList: (state) => {
      return state.allCategoryTrees.sort(function(a, b){
        if(a.CategoryTreePathForwards < b.CategoryTreePathForwards) { return -1; }
        if(a.CategoryTreePathForwards > b.CategoryTreePathForwards) { return 1; }
        return 0;
      })
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setLanguages: function(state, data){
      state.allLanguages = data
    },
    setSearchResults: function(state, data){
      state.searchResults = data
    },
    setCurrentTag: function(state, data){
      state.tagId = data.ID
      state.tagName = data.RetailerTagName
      state.tagText = data.RetailerTagDescription
      state.tagImage = data.RetailerTagImage
      state.tagDisplayOrder = data.DisplayOrder
      state.revision = data.Revision
    },
    setAssociatedCategories: function(state, data){
      state.associatedCategories = data
    },
    updateTreeChild: function(state, data){
      state.allCategoryTrees = state.allCategoryTrees.map( item => {
        if (item.TreeID == data.treeId) item.children = data.children
        return item
      })
    }
  },
}
